module.exports = __webpack_public_path__ + "img/01.afa88724.jpg";